import API from 'api/api';
import { useState, useEffect, useRef } from 'react';
import { translateApiError } from 'i18n/translateApiError';

export function useCheckIfUserExistsByEmail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const checkIfUserExistsByEmail = async (email) => {
    setLoading(true);
    setError(null);

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const res = await API.get(`/users/check-exists/${email}`);
      console.log('Email exists:', res.data);
      return res?.data;
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
        return;
      }
      console.error('Failed to add booking to user:', err);
      setError(translateApiError(err, 'Failed to add booking to user'));
    } finally {
      setLoading(false);
    }
  };

  return { checkIfUserExistsByEmail, loading, error };
}
